export default __webpack_public_path__ + "static/illustration-content.url-a9d269ff94744050b6b5815a990f0d3e.svg";